import axios from 'axios';
import moment from 'moment-timezone';

function getCurrentTimeForZone(timeZone = 'UTC') {
    return moment().tz(timeZone).format('YYYY-MM-DD HH:mm:ss');
  }
//const currentTimeEST = getCurrentTimeForZone('America/New_York');

// Create an Axios instance with default configurations
const axiosInstance = axios.create({
    // Base URL for API requests...
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Add extra information to the request config for PUT requests
    //if (config.method === 'put')

    // the res.body will be
    // {"..." : ... , 
    //  "extraInfo": {"sqlCommandOperatorName": name},
    //  "..." : ... 
    //}
    // note that the "extraInfo" key contains a dictionary
    // so in the future we can add more information to the response
    // for example, token, user id, etc.

    let extraInfo = {
        "sqlCommandOperatorName": JSON.parse(localStorage.getItem('user')).UserName,
        "userLocationCode": JSON.parse(localStorage.getItem('user')).LocationCode,
        "currentTime": getCurrentTimeForZone('America/New_York'),
    }; // Add any extra data you want to include

    if (!config.data) {
        config.data = {"axiosInterceptorPlaceHolder": "axiosInterceptorPlaceHolder"}; // Create an empty object
    }

    // console.log(extraInfo);
    // console.log(config);
    // console.log(config.data);

    config.data.extraInfo = extraInfo;
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { axiosInstance };